import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Pagination,
  CircularProgress,
  Paper,
  Stack,
  styled,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link, useNavigate } from "react-router-dom";
import {
  fetchProductProvider,
  fetchProvider,
} from "../redux/actions/xmlAction";
import { useDispatch, useSelector } from "react-redux";
import xmlService from "../services/xmlService";
import XmlRunTimeModal from "../components/UI/reusable-components/xmlComponents/XmlRunTimeModal";
import { APP_CONFIG } from "../config/appConfig";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: theme.palette.text.primary,
  textAlign: "left",
}));

export const XmlProductSourcePage = () => {
  const [expanded, setExpanded] = useState(false);
  const [providerIds, setProviderIds] = useState(null);
  const [page, setPage] = useState(1);
  const [logs, setLogs] = useState([]);
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const [totalPages, setTotalPages] = useState(0);
  const [loadingLog, setLoadingLog] = useState(false);
  const [selectedRunTimeId, setSelectedRunTimeId] = useState(0);
  const [open, setOpen] = useState(false);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const dispatch = useDispatch();
  const getProductProviders = async () => {
    try {
      await dispatch(fetchProductProvider(authUserId, token));
    } catch (error) {
      console.error("Failed to fetch product providers", error);
    }
  };
  const handleCloseModal = () => {
    setOpen(false);
    setSelectedRunTimeId(0);
  };
  const xml = useSelector((state) => state?.xml?.xml || []);
  const rules = [
    { text: "Maksimum 3 adet XML yükleme hakkınız bulunmaktadır." },
    {
      text: "Tüm XML dosyaları, ürün limiti 10.000 adetle sınırlıdır. 10.000 adedin üzerindeki ürünler ek ücretlendirmeye tabidir ",
    },
    {
      text: "XML dosyaları, 12-24 saatlik periyotlarla bir kez güncellenmektedir. Özel güncelleme saatleri talep edilmesi durumunda ek ücret uygulanır",
    },
    {
      text: "XML destek talepleri 24 ile 48 saat içerisinde cevaplanmaktadır.",
    },
    {
      text: "XML entegrasyonu hizmeti sadece Profesyonel ve Gelişmiş paketlerimizde verilmektedir.",
    },
    { text: "Deneme yapmak için maksimum 1 adet XML tanımlaması yapılır." },
    {
      text: "Profesyonel veya Gelişmiş paket satın alımında eğer ilgili kategori destekliyorsa toplu ürün gönderimi yapılabilmektedir.",
    },
  ];

  const sections = [
    {
      id: "panel1",
      title: "Aktif XML Kaynaklarınız",
      count: xml?.filter((item) => item.state === 2).length || 0,
      content: (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Adı</TableCell>
                <TableCell>Link</TableCell>
                <TableCell>Oluşturma Tarihi</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {xml
                ?.filter((item) => item.state === 2)
                .map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>
                      <Link href={item.link} target="_blank">
                        {item.link}
                      </Link>
                    </TableCell>
                    <TableCell>{item.createDate}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      ),
    },
    {
      id: "panel2",
      title: "Bekleyen XML Entegrasyon Talepleriniz",
      count: xml?.filter((item) => item.state === 1).length || 0,
      content: (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Adı</TableCell>
                <TableCell>Link</TableCell>
                <TableCell>Oluşturma Tarihi</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {xml
                ?.filter((item) => item.state === 1)
                .map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>
                      <Link href={item.link} target="_blank">
                        {item.link}
                      </Link>
                    </TableCell>
                    <TableCell>{item.createDate}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      ),
    },
    {
      id: "panel3",
      title: "Hatalı XML Kaynaklarınız",
      count: xml?.filter((item) => item.state === 3).length || 0,
      content: (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Adı</TableCell>
                <TableCell>Link</TableCell>
                <TableCell>Oluşturma Tarihi</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {xml
                ?.filter((item) => item.state === 3)
                .map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>
                      <Link href={item.link} target="_blank">
                        {item.link}
                      </Link>
                    </TableCell>
                    <TableCell>{item.createDate}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      ),
    },
  ];
  const navigate = useNavigate();

  const addXml = () => {
    navigate("/XmlProductSourceAddPage");
  };

  const getRunTimes = async () => {
    try {
      if (providerIds.length == 0) {
        return;
      }
      setLoadingLog(true);
      const params = {
        providerIds: providerIds,
        Page: page,
      };
      const respone = await xmlService.fetchRunTimes(params);
      const data = respone?.data?.data;
      data?.forEach((element) => {
        const matchingXml = xml.find((x) => x.id === element.providerId);
        element.type = matchingXml ? matchingXml.providerNextRuns[0].type : 0;
      });
      setLogs(data);
      const totalPage = Math.ceil(respone?.data?.recordsTotal / 10);
      setTotalPages(totalPage);
      setLoadingLog(false);
    } catch (exx) {
      setLoadingLog(false);
    }
  };
  useEffect(() => {
    getProductProviders();
  }, []);

  useEffect(() => {
    const providerIds = xml.map((i) => i.id);
    setProviderIds(providerIds);
  }, [xml]);
  useEffect(() => {
    if (providerIds?.length > 0) {
      getRunTimes();
    }
  }, [providerIds]);
  const openXmlRuntimeModal = (runTimeId) => async () => {
    setSelectedRunTimeId(runTimeId);
    setOpen(true);
  };
  const handlePageChange = (event, value) => {
    setPage(value);
  };
  useEffect(() => {
    getRunTimes();
  }, [page]);

  const ProviderStatus = (type) => {
    switch (type) {
      case 1:
        return "Yeni ürün";
      case 2:
        return "Stok güncelleme";
      case 3:
        return "Yeni kategori";
      default:
        return "Bilinmiyor";
    }
  };
  console.log("logs", logs);
  return (
    <Box
      sx={{
        flexGrow: 1,
        p: { xs: 1, sm: 2, md: 3 },
        paddingTop: { xs: 6, sm: 7, md: 8 },
      }}
    >
      <Container maxWidth={false}>
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={7}>
            <Card sx={{ mb: { xs: 2, sm: 3, md: 4 } }}>
              <CardContent
                sx={{
                  background: "#F7F9FC",
                  p: { xs: 2, sm: 3 },
                }}
              >
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
                    fontWeight: 600,
                  }}
                >
                  XML Bilgilendirme
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  paragraph
                  sx={{
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                    mb: { xs: 1, sm: 2 },
                  }}
                >
                  - {APP_CONFIG.name}'in XML çalışma mantığı aşağıda
                  belirtildiği şekildedir. Aşağıda belirtilen koşullar dışında
                  ekstra hizmet verilememektedir.
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  paragraph
                  sx={{
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                    mb: { xs: 1, sm: 2 },
                  }}
                >
                  - Xml tedarikçinizin Ip kısıtı var ise 207.38.89.173 Ip
                  adresine izin verilmelidir
                </Typography>
                <Typography
                  variant="h6"
                  color="primary"
                  sx={{
                    mt: { xs: 2, sm: 3 },
                    mb: { xs: 1, sm: 2 },
                    fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.5rem" },
                  }}
                >
                  XML KURALLARIMIZ
                </Typography>

                <List sx={{ py: 0 }}>
                  {rules.map((rule, index) => (
                    <ListItem
                      key={index}
                      sx={{
                        py: 0.5,
                        "& .MuiListItemText-primary": {
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                        },
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: { xs: 36, sm: 40 } }}>
                        <CheckIcon
                          color="success"
                          sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={rule.text} />
                    </ListItem>
                  ))}
                </List>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    mt: { xs: 2, sm: 3, md: 4 },
                    gap: { xs: 1, sm: 2 },
                  }}
                >
                  <Button
                    variant="contained"
                    startIcon={
                      <AddIcon
                        sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
                      />
                    }
                    sx={{
                      paddingX: { xs: 2, sm: 3 },
                      paddingY: { xs: 1, sm: 1.2 },
                      backgroundColor: "#1F1B45",
                      color: "#FFFFFF",
                      borderRadius: "20px",
                      fontWeight: 600,
                      fontSize: { xs: "0.75rem", sm: "0.875rem" },
                      textTransform: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      boxShadow: "0 4px 8px rgba(31, 27, 69, 0.3)",
                      width: { xs: "100%", sm: "auto" },
                      "&:hover": {
                        backgroundColor: "#2C285A",
                        boxShadow: "0 6px 12px rgba(31, 27, 69, 0.4)",
                      },
                    }}
                    onClick={addXml}
                  >
                    YENİ XML ÜRÜN KAYNAĞI TANIMLA
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={5}>
            {sections.map((section) => (
              <Accordion
                key={section.id}
                expanded={expanded === section.id}
                onChange={handleChange(section.id)}
                sx={{
                  mb: 1,
                  "&:before": { display: "none" },
                  boxShadow: 1,
                  background: "#F7F9FC",
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon
                      sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
                    />
                  }
                  sx={{
                    "& .MuiAccordionSummary-content": {
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      background: "#F7F9FC",
                      py: { xs: 1, sm: 1.5 },
                    },
                  }}
                >
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{
                      fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                      fontWeight: 600,
                    }}
                  >
                    {section.title}
                  </Typography>
                  {section.count !== null && (
                    <Typography
                      color="text.secondary"
                      sx={{
                        ml: 2,
                        fontSize: { xs: "0.875rem", sm: "1rem" },
                      }}
                    >
                      ({section.count})
                    </Typography>
                  )}
                </AccordionSummary>
                <AccordionDetails sx={{ p: { xs: 1, sm: 2 } }}>
                  <TableContainer
                    sx={{
                      "& .MuiTableCell-root": {
                        fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        py: { xs: 1, sm: 1.5 },
                        px: { xs: 1, sm: 2 },
                      },
                    }}
                  >
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Adı</TableCell>
                          <TableCell>Link</TableCell>
                          <TableCell>Oluşturma Tarihi</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          section.content.props.children.props.children[1].props
                            .children
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            ))}
            {logs.length > 0 && (
              <Grid
                sx={{
                  background: "#F7F9FC",
                  p: { xs: 1, sm: 2 },
                  mt: { xs: 1, sm: 2 },
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                    mb: { xs: 1, sm: 2 },
                  }}
                >
                  XML Çalışma zamanları
                </Typography>

                {loadingLog ? (
                  <Box
                    sx={{ display: "flex", justifyContent: "center", py: 2 }}
                  >
                    <CircularProgress size={24} />
                  </Box>
                ) : (
                  logs.map((log, index) => (
                    <Stack sx={{ mb: 1 }} key={index} spacing={1}>
                      <Item sx={{ p: { xs: 1, sm: 2 } }}>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{
                            fontSize: { xs: "0.75rem", sm: "0.875rem" },
                            display: "block",
                            mb: 0.5,
                          }}
                        >
                          {new Date(log.createDate).toLocaleString("tr-TR")}
                        </Typography>
                        <Button
                          onClick={openXmlRuntimeModal(log.id)}
                          size="small"
                          sx={{
                            fontSize: { xs: "0.75rem", sm: "0.875rem" },
                            mb: 0.5,
                            color: "#424242",
                            textTransform: "none",
                            "&:hover": {
                              backgroundColor: "rgba(0, 0, 0, 0.04)",
                            },
                          }}
                        >
                          Listeyi gör
                        </Button>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{
                            fontSize: { xs: "0.75rem", sm: "0.875rem" },
                            display: "block",
                          }}
                        >
                          XML türü: {ProviderStatus(log.type)}
                        </Typography>
                      </Item>
                    </Stack>
                  ))
                )}

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 2,
                    "& .MuiPaginationItem-root": {
                      fontSize: { xs: "0.75rem", sm: "0.875rem" },
                      minWidth: { xs: "32px", sm: "40px" },
                      height: { xs: "32px", sm: "40px" },
                    },
                  }}
                >
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                    variant="outlined"
                    size="medium"
                  />
                </Box>
              </Grid>
            )}
          </Grid>
          <XmlRunTimeModal
            open={open}
            handleCloseModal={handleCloseModal}
            runTimeId={selectedRunTimeId}
          />
        </Grid>
      </Container>
    </Box>
  );
};
